// extracted by mini-css-extract-plugin
export default {"page":"Exams_page__JcXf6","container":"Exams_container__2+jtz","header":"Exams_header__ZZZkk","bar":"Exams_bar__sQloR","table":"Exams_table__Y3e3O"};